export default __webpack_public_path__ + "static/media/mission.509f3c8a.jpg";